export default {
    title: "Proizvodi",
    tabs: {
        allProducts: "Svi proizvodi",
        inventory: "Inventar",
        collection: "Kolekcije",
        priceList: "Cjenovne liste",
    },
    table: {
        product: "Proizvodi",
        details: "Detalji",
        quantity: "Količina",
        price: "Cijena",
        supplement: "Doplata"
    },
    allProducts: {
        paginatorText: "proizvoda",
        addProduct: "Dodaj proizvod",
        search: "Pretraži proizvode",
        chooseCategory: "Sve kategorije",
        chooseStatus: "Svi statusi",
        allCategories: "Sve kategorije",
        allStatuses: "Svi statusi",
        table: {
            isSelected: "označenih", // ToDo check if in use
            product: "Proizvod",
            quantity: "Količina",
            category: "Kategorija",
            active: "Aktivan",
            vendor: "Proizvođač",
            in: "u",
            variants: "varijanti"
        },
        statuses: {
            allStatuses: "Svi Statusi",
            allCategories: "Sve kategorije",
            active: "Aktivani",
            inactive: "Neaktivani",
            scheduled: "Zakazani"
        },
        activateSuccessMessage: "Proizvodi su uspješno aktivirani.",
        deactivateSuccessMessage: "Proizvodi su uspješno deaktivirani.",
        deleteMultipleSuccessMessage: "Proizvodi su uspješno izbrisani.",
        deleteSuccessMessage: "Proizvod je uspješno izbrisan."
    },
    inventory: {
        paginatorText: "proizvoda i varijanti",
        search: "Pretraži Inventar",
        chooseCategory: "Sve kategorije",
        chooseStatus: "Svi statusi",
        allStatuses: "Svi Statusi",
        allCategories: "Sve kategorije",
        table: {
            productAndVariants: "Proizvod i varijante",
            isSelected: "označenih", // ToDo check if in use
            quantity: "Količina",
            token: "Token",
            category: "Kategorija",
            active: "Aktivan",
            price: "Cijena",
            cancel: "Poništi",
            save: "Sačuvaj",
            edit: "Izmijeni",
        },
        statuses: {
            active: "Aktivani",
            inactive: "Neaktivani",
            scheduled: "Zakazani"
        },
        paginationError: "Promjene neće biti sačuvane.",
    },
    collections: {
        paginatorText: "kolekcije(a)",
        addCollection: "Dodaj kolekciju",
        search: "Pretraži kolekcije",
        table: {
            name: "Naziv",
            quantity: "Proizvoda u kolekciji",
            active: "Aktivan",
            createdAt: "Datum kreiranja"
        },
        statuses: {
            allStatuses: "Svi Statusi",
            allCategories: "Sve kategorije",
            active: "Aktivani",
            inactive: "Neaktivani",
            scheduled: "Zakazani"
        },
        activateSuccessMessage: "Kolekcije su uspješno aktivirane.",
        deactivateSuccessMessage: "Kolekcije su uspješno deaktivirane.",
        deleteMultipleSuccessMessage: "Kolekcije su uspješno izbrisane.",
    },
};
